/** Devolução de venda — conferência da quantidade digitada (a API confere de novo). */
import { formatQuantity } from "@cafegestor/shared";
import { toDecimal } from "@/lib/decimal";

/** Erro da quantidade a devolver, ou null (vazio = não devolve este item). */
export function returnQuantityError(typed: string, returnable: string): string | null {
  const t = typed.trim();
  if (t === "") return null;
  if (!/^\d+([.,]\d{1,4})?$/.test(t)) return "Use número com até 4 casas (ex.: 2,5).";
  const n = Number(toDecimal(t));
  if (n <= 0) return null;
  if (n > Number(returnable)) return `No máximo ${formatQuantity(returnable)}.`;
  return null;
}
